@if (loading || loadError) {
<div class="container breathe mt-5">
  @if (loading) {
<p>Loading user-experience data…</p>
}
  @if (loadError) {
<p role="alert">User-experience data is temporarily unavailable. Please try again later.</p>
}
</div>
}
@if (subjectSummary?.tableName && subjectDataSummary?.tableName) {
<div
  class="container breathe mt-5"
 
>
  <div class="row datasets">
    @for (entry of tabNames; track entry) {
<div
      class="col dataset p-3"
     
      [class.active]="selectedData === entry"
      (click)="onSelectionChange(entry)"
    >
      {{ entry }}
    </div>
}
  </div>

  <div class="centered mt-5 breathe">
    <a
      class="btn btn-lg btn-primary"
      href="{{ 'ui.projects.drivetesting.download-report-link' | translate }}"
      target="_blank"
    >
      {{ "ui.projects.drivetesting.download-report" | translate }}
      <fa-icon [icon]="icons.falFilePdf" class="ml-2"></fa-icon>
    </a>
  </div>

  <table class="wide d-none d-md-table">
    <tr class="column-titles">
      <th class="title" scope="col" colspan="2">{{ subjectSummary.tableName }}</th>
      @for (operator of subjectSummary.providers; track operator) {
<th
         
          [attr.id]="operator"
          [className]="'data-column ' + operator | lowercase"
          scope="col">
        {{ operator }}
      </th>
}
    </tr>

    @for (category of subjectSummary.categories; track category) {

      <tr class="inbetween-title" [attr.headers]="category.data.header">
        <th colspan="5" scope="col">{{ category.subTable }}</th>
      </tr>

      @for (row of category.data; track row) {
<tr class="data-row" [attr.headers]="category.data.header">
        <th class="data-row-title"
            [attr.id]="row.header | hyphenate"
            scope="row">
          {{ row.header }}
        </th>
        <td class="data-row-unit"
            [attr.headers]="row.header | hyphenate">
          {{ row.ratio }}
        </td>
        @for (value of row.values; track value; let j = $index) {
<td class="data-column"
           
            [attr.headers]="subjectSummary.providers[j]">
          {{ value }}
        </td>
}
      </tr>
}
    
}
  </table>

  <table class="not-wide d-table d-md-none">
    <tr class="table-title">
      <th colspan="3" scope="col">{{ subjectSummary.tableName }}</th>
    </tr>

    @for (category of subjectSummary.categories; track category) {

      <tr class="category-title">
        <th colspan="3" scope="col">{{ category.subTable }}</th>
      </tr>

      <tr class="operators">
        @for (operator of subjectSummary.providers; track operator) {
<th
         
          id="{{category.subTable+'-'+operator | hyphenate}}"
          [class]="operator | lowercase"
          scope="col"
        >
          {{ operator }}
        </th>
}
      </tr>

      @for (row of category.data; track row; let i = $index) {

        <tr class="data-title">
          <th colspan="3" [attr.id]="(row.header+'-mini') | hyphenate" scope="row">
            {{ row.header }} <span class="data-unit">({{ row.ratio }})</span>
          </th>
        </tr>

        <tr class="data-row">
          @for (value of row.values; track value; let j = $index) {
<td
            [attr.header]="(row.header+'-'+subjectSummary.providers[j]) | hyphenate">
            {{ value }}
          </td>
}
        </tr>
      
}
    
}
  </table>

  <h3 class="mt-5">Data results</h3>

  <table class="wide d-none d-md-table">
    <tr class="column-titles">
      <th class="title" scope="col" colspan="3">{{ subjectDataSummary.tableName }}</th>
      @for (operator of subjectDataSummary.providers; track operator) {
<th
       
        id="{{(subjectDataSummary.tableName + operator) | hyphenate}}"
        [className]="'data-column ' + operator | lowercase"
        scope="col">
        {{ operator }}
      </th>
}
    </tr>

    @for (category of subjectDataSummary.categories; track category) {

      <tr class="inbetween-title">
        <th colspan="6" scope="col">{{ category.subTable }}</th>
      </tr>

      @for (row of category.rows; track row) {

        @for (subRow of row.subRows; track subRow; let i = $index) {
<tr class="data-row">
          @if (i === 0) {
<th
            class="data-row-title"
           
            [attr.rowspan]="row.subRows.length"
            [attr.id]="row.header | hyphenate"
            scope="row"
          >
            {{ row.header }}
          </th>
}
          @if (i === 0 || row.subRows.length === row.info.length) {
<td
            class="data-row-subcategory"
           
            [attr.rowspan]="row.subRows.length / row.info.length"
          >
            {{ row.info[i] }}
          </td>
}
          <td class="data-row-unit">{{ subRow.ratio }}</td>
          @for (value of subRow.values; track value) {

            <td class="data-column">{{ value }}</td>
          
}
        </tr>
}
      
}
    
}
  </table>

  <table class="not-wide d-table d-md-none">
    <tr class="table-title">
      <th colspan="3"  scope="col">{{ subjectDataSummary.tableName }}</th>
    </tr>

    <tr class="operators">
      @for (operator of subjectDataSummary.providers; track operator) {
<th
       
        [class]="operator | lowercase"
        scope="col"
      >
        {{ operator }}
      </th>
}
    </tr>

    @for (category of subjectDataSummary.categories; track category) {

      <tr class="category-title">
        <th colspan="3" [attr.id]="(category.subTable+'-mini') | hyphenate" scope="row"
        >{{ category.subTable }}</th>
      </tr>

      @for (row of category.rows; track row) {

        <tr class="row-title">
          <th colspan="3" [attr.id]="(row.header+'-mini') | hyphenate" scope="row">
            {{ row.header }}
            @if (row.info.length === 1) {

              <br />
              <span class="altlabel">{{ row.info[0] }}</span>
            
}
          </th>
        </tr>

        @for (subRow of row.subRows; track subRow; let i = $index) {

          <tr class="data-title">
            <th colspan="3" [attr.id]="(row.header+'-'+row.info[i]) | hyphenate" scope="row">
              @if (row.subRows.length === row.info.length) {

                <span class="subrow-label">{{ row.info[i] }}</span>
                <br />
              
}
              {{ subRow.ratio }}
            </th>
          </tr>

          <tr class="data-row">
            @for (value of subRow.values; track value; let j = $index) {
<td
            [attr.header]="(row.header+'-'+subjectSummary.providers[j]) | hyphenate">{{ value }}</td>
}
          </tr>
        
}
      
}
    
}
  </table>

  <div class="centered mt-5">
    <a
      class="btn btn-lg btn-primary"
      href="{{ 'ui.projects.drivetesting.download-report-link' | translate }}"
      target="_blank"
    >
      {{ "ui.projects.drivetesting.download-report" | translate }}
      <fa-icon [icon]="icons.falFilePdf" class="ml-2"></fa-icon>
    </a>
  </div>
</div>
}
